import { storage } from "lib";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  REQUEST_APPROVAL_TYPE,
  REQUEST_APPROVAL_TYPE_LIST,
} from "../schemas/RequestApprovalSchema";

import * as service from "../../myDocument/services/myDocumentApi";
import * as services from "../service/pendingApprovalApi";
import * as masterDataServices from "features/masterData/services/optionsApi";
import { setWorkInLocation, setIsLoading } from "features/myDocument/slices/myDocumentSlice";
import * as myDocumentServices from "features/myDocument/services/myDocumentApi";
import {
  setHistoryChangeShiftList,
  setHistoryCollectTimeList,
  setHistoryDocumentList,
  setHistoryEndorseTimeList,
  setHistoryExpense,
  setHistoryLeaveList,
  setHistoryMovement,
  setHistoryOffsiteWorkList,
  setHistoryOvertimeList,
  setHistoryRedeemTimeList,
  setHistoryWarningLetterList,
  setPendindExpenseList,
  setPendingChangeShiftList,
  setPendingCollectTimeList,
  setPendingDocumentList,
  setPendingEndorseTimeList,
  setPendingLeaveList,
  setPendingMovement,
  setPendingOffsiteWorkList,
  setPendingOvertimeList,
  setPendingRedeemTimeList,
  setPendingWarningLetterList
} from "../slices/requestApprovalSlice";

import { Checkbox, Col, Dropdown, Modal, Row, Card, Tabs, Space, Table, Tag, Flex, message } from "antd";

// import { Flex, Modal } from "antd";
import { Alert } from "components/elements";
import ChangeShiftTable from "components/table/ChangeShiftTable";
import dayjs from "dayjs";
import LeaveForm from "features/myDocument/components/LeaveForm";
import { useTranslation } from "react-i18next";
import { generateRandomString } from "utils/helper";
import Movement from "../pages/MovementPage";
import PendingApprovalContent from "../pages/PendingApprovalContent";
import WarningLetter from "../pages/WarningLetterPage";
import { REQUEST_APPROVE_TAB } from "../schemas/RequestApproveTab";
import PendingApprovalCollectTimeTable from "../table/pendingApprovalTables/PendingApprovalCollectTimeTable";
import PendingApprovalEndorseTimeTable from "../table/pendingApprovalTables/PendingApprovalEndorseTimeTable";
import PendingApprovalExpenseTable from "../table/pendingApprovalTables/PendingApprovalExpenseTable";
import PendingApprovalLeaveTable from "../table/pendingApprovalTables/PendingApprovalLeaveTable";
import PendingApprovalOffsiteWorkTable from "../table/pendingApprovalTables/PendingApprovalOffsiteWorkTable";
import PendingApprovalOvertimeTable from "../table/pendingApprovalTables/PendingApprovalOvertimeTable";
import PendingApprovalRedeemTimeTable from "../table/pendingApprovalTables/PendingApprovalRedeemTimeTable";
import RequestFormTable from "../table/requestTables/RequestAllTable";
// import useRequest from "./useRequest";
import useRequestApproveOption from "./useRequestApproveOption";
import OvertimeForm from "features/myDocument/components/OvertimeForm";
import OffsiteForm from "features/myDocument/components/OffsiteForm";
import EndorseTimeForm from "features/myDocument/components/EndorseTimeForm";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { MY_REQUEST_TYPE } from "../schemas/MovementSchema";
import useExpenseMainComponent from "features/Expense/hook/useExpenseMainComponent";
import { setTxnExpenseById } from "features/Expense/slices/ExpenseSlices";
import DocumentForm from "features/myDocument/components/DocumentForm";
import useMyRequest from "features/myDocument/hooks/useMyRequest";
import WarningLetterForm from "features/myDocument/components/WarningLetterForm";



const PAGE_TYPE = {
  view: "view",
  edit: "edit",
  delete: "delete",
  main: "main",
  create: "create",
};

function toParams(params) {
  const { pagination = {}, sortBy = [] } = params;
  const modifiedParams = {
    pagination: {
      page: pagination?.page,
      size: pagination?.pageSize,
    },
    sortBy: sortBy
      .filter((s) => s.order !== undefined)
      .map((s) => ({
        direction: s.order === "descend" ? "desc" : "asc",
        property: s.field,
      })),
  };
  return modifiedParams;
}

function useRequestApproval() {
  const dispatch = useDispatch();
  const [sorter, setSorter] = useState([]);
  const [selectedMenu, setMenu] = useState("profile");
  const [pageType, setPageType] = useState(PAGE_TYPE.view);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [pendingTab, setPendingTab] = useState(REQUEST_APPROVE_TAB.LEAVE);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [selectedMenuModal, setMenuModal] = useState(MY_REQUEST_TYPE.DETAIL);
  const [defaultValue, setDefaultValue] = useState(dayjs());
  const [currentMyRequest, setCurrentMyRequest] = useState({});
  const [recordData, setRecordData] = useState({});
  const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selecttable, settable] = useState(null);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [listEmployees, setListEmployees] = useState({});
  const [currentWorkflow, setCurrentWorkflow] = useState([]);
  const [disabledDateRange, setDisabledDateRange] = useState({
    startYear: dayjs("2024-01-01"),
    endYear: dayjs("2034-12-31"),
  });
  const [useFilter, setUseFilter] = useState(false);
  const { pendingMovement = [] } = useSelector((state) => state.requestApproval)

  const { i18n, t } = useTranslation();
  const isLoading = useSelector((state) => state.requestApproval.isLoading);
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const currentApprover = useSelector((state) => state.company.currentEmployee);
  const {
    pendingDocumentList,
    pendingChangeShiftList,
    historyLeaveList,
    historyOffsiteWorkList,
    historyRedeemTimeList,
    historyEndorseTimeList,
    historyOvertimeList,
    historyCollectTimeList,
    historyWarningLetterList,
    historyDocumentList,
    historyChangeShiftList,
    historyExpense,
    historyMovement,
  } = useSelector((state) => state.requestApproval);
  const getLeaveRequest = useSelector(
    (state) => state.requestApproval.pendingLeaveList
  );
  const getOffsiteWorkRequest = useSelector(
    (state) => state.requestApproval.pendingOffsiteWorkList
  );
  const getRedeemTimeRequest = useSelector(
    (state) => state.requestApproval.pendingRedeemTimeList
  );
  const getEndorseTimeRequest = useSelector(
    (state) => state.requestApproval.pendingEndorseTimeList
  );
  const getOvertimeRequest = useSelector(
    (state) => state.requestApproval.pendingOvertimeList
  );
  const getCollectTimeRequest = useSelector(
    (state) => state.requestApproval.pendingCollectTimeList
  );
  const getPendingExpenseSlice = useSelector((state) => state.requestApproval.pendingExpense)
  const txnExpenseById = useSelector((state) => state.expense.txnExpenseById);

  const {
    // modifiedLeaveGroupOptions = [],
    modifiedEmployeeOptions = [],
    modifiedOffSiteOptions = [],
    modifiedCompanyRegulationOptions = [],
    modifiedDocumentTypeOptions = [],
    modifiedPenaltiesOptions = [],
    getOffSiteOptions,
    getCompanyRegulationOptions,
    getDocumentTypeOptions,
    getPenaltiesOptions,
  } = useRequestApproveOption();
  useEffect(() => {
    if (!currentCompany) return;
    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        getOffSiteOptions?.();
        break;
      case REQUEST_APPROVE_TAB.REQUESTFORM:
        getDocumentTypeOptions?.();
        break;
      case REQUEST_APPROVE_TAB.WARNING_LETTER:
        getCompanyRegulationOptions?.();
        getPenaltiesOptions?.();
        break;
      default:
        break;
    }
  }, [pendingTab, currentCompany]);
  const onOffsiteWorkTypeChange = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true));
      const response = await myDocumentServices.getDropdownWorkInLocation({
        companyId: currentCompany,
        employeeId: values?.employeeId ? values.employeeId : currentApprover,
        leaveTypeCompanyId: values?.id
      });
      dispatch(setWorkInLocation(response?.data?.content));
    } catch (error) {
      console.log("error message : ", error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentApprover, dispatch]);

  const workInLocation = useSelector((state) => state.myDocument.workInLocation);
  const modifiedWorkInLocationOption = useMemo(() => {
    return workInLocation?.map((opt) => ({
      ...opt,
      value: opt?.workInLocationId,
      label: opt?.workInLocationName
    }));
  }, [workInLocation]);

  const handleMenuChangeModal = useCallback(
    (e) => {
      setMenuModal(e);
      console.log("🚀 ~ handleMenuChangeModal ~ e:", e)
    },
    [setMenuModal]
  );

  let language = i18n.language === 'en' ? "En" : ""



  function formatDateTime(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
  }


  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    // getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ),

  ];


  const modifiedLeaveGroupOptions = useMemo(() => {
    return leaveGroupOptions?.map((opt) => ({

      ...opt,
      unlimited: opt?.unlimited ? opt?.unlimited : 'N',
      emergencyFlag: opt?.emergencyFlag ? opt?.emergencyFlag : 'N',
      emergencyUsed: opt?.emergencyUsed ? opt?.emergencyUsed : 0,
      remainingLeaveDays: opt?.remainingLeaveDays,
      remainingLeaveHour: opt?.remainingLeaveHour,
      label: i18n.language === "en" ? opt?.leaveTypeNameEn : opt?.leaveTypeName,
      value: opt?.leaveId,
    }));
  }, [i18n, leaveGroupOptions]);



  // const { modifiedDocumentTypeOptions = [], getDocumentTypeOptions = () => { } } = useRequest();

  const onEdit = useCallback(() => {
    setPageType(PAGE_TYPE.edit);
  }, [setPageType]);

  const onView = useCallback(() => {
    setPageType(PAGE_TYPE.view);
  }, [setPageType]);

  const getTxnExpenseById = useCallback(
    async (id) => {
      if (!currentCompany || !currentEmployee) return null;
      dispatch(setIsLoading(true));
      try {
        const response = await services.getMyTxnExpenseById({
          companyId: currentCompany,
          employeeId: currentEmployee,
          txnExpenseId: id,
        });
        const data = response?.data?.content || {};
        dispatch(setTxnExpenseById(data));
        return data;
      } catch (error) {
        return null;
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, dispatch]
  );

  const onViewApproveExpense = useCallback((record) => {
    getTxnExpenseById(record.requestId)
  }, [getTxnExpenseById])

  const getLeaveGroupOptions = useCallback(async (value) => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: value.employeeId.employeeId,
        };
        const response = await masterDataServices.getLeaveGroupIsLeave(values);
        console.log("🚀 ~ getLeaveGroupOptions ~ response:", response)
        setLeaveGroupOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, currentApprover, dispatch]);


  const getWorkflow = (async ({ employeeId = "", flowRequestId = "" }) => {
    let data = [];

    data = await services.getWorkflowByRequestId({
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: employeeId,
      flowRequestId: flowRequestId,
    });
    setCurrentWorkflow(data?.data?.approvalSequence)

  })



  const onMain = useCallback(() => {
    setPageType(PAGE_TYPE.main);
  }, [setPageType]);

  const onPendingTabChange = useCallback(
    async (e) => {
      await setPendingTab(e);
    },
    [pendingTab]
  );

  const parseDataByMovementType = (oldData, newData, movementTypeName, movementTypeCode) => {
    if (!movementTypeName) return [];

    const oldDataString = JSON.stringify(oldData);
    const newDataString = JSON.stringify(newData);

    const movementTypes = movementTypeName.split(",").map((type) => type.trim());
    const oldDataSegments = oldDataString ? oldDataString.split("\n").filter((segment) => segment.trim() !== "") : [];
    const newDataSegments = newDataString ? newDataString.split("\n").filter((segment) => segment.trim() !== "") : [];

    while (oldDataSegments.length < movementTypes.length) {
      oldDataSegments.push("{}");
    }
    while (newDataSegments.length < movementTypes.length) {
      newDataSegments.push("{}");
    }

    return movementTypes.flatMap((movementType, index) => {
      const oldSegment = oldDataSegments[index];
      const newSegment = newDataSegments[index];

      console.log("newSegment", newSegment)

      try {
        const oldParsed = oldSegment ? JSON.parse(oldSegment) : {};
        const newParsed = newSegment ? JSON.parse(newSegment) : {};

        const formatDateArray = (dateArray) => {
          if (Array.isArray(dateArray) && dateArray.length === 3) {
            return `${dateArray[0]}/${String(dateArray[1]).padStart(2, '0')}/${String(dateArray[2]).padStart(2, '0')}`;
          }
          return "-";
        };

        const getNamePair = (value, isSupervisor = false) => {
          if (!value || typeof value !== "object") {
            return { th: value || "-", en: value || "-" };
          }

          if (Array.isArray(value)) {
            const namesTh = value.map((v) => {
              if (!v || typeof v !== "object") return "-";
              const name = v.name || "-";
              const surName = v.surName;
              return surName ? `${name} ${surName}` : name;
            });

            const namesEn = value.map((v) => {
              if (!v || typeof v !== "object") return "-";
              const nameEn = v.nameEn || "-";
              const surNameEn = v.surNameEn;
              return surNameEn ? `${nameEn} ${surNameEn}` : nameEn;
            });

            return {
              th: namesTh.join(", "),
              en: namesEn.join(", "),
            };
          }

          const name = value.name || "-";
          const surName = value.surName;
          const nameEn = value.nameEn || "-";
          const surNameEn = value.surNameEn;

          if (movementType === "ย้ายสายบังคับบัญชา" && isSupervisor) {
            return {
              th: surName ? `${name} ${surName}` : name,
              en: surNameEn ? `${nameEn} ${surNameEn}` : nameEn,
            };
          }

          return {
            th: name,
            en: nameEn,
          };
        };

        if (movementTypeCode === "MOVEMENT_01_05") {
          return [
            {
              movementTypeName: movementType,
              index: index + 1,
              field: "daysProbation",
              oldValue: oldParsed.daysProbation || "-",
              newValue: newParsed.daysProbation || "-",
              oldValueEn: oldParsed.daysProbation || "-",
              newValueEn: newParsed.daysProbation || "-",
            },
            {
              movementTypeName: movementType,
              index: index + 1,
              field: "dateContractExpire",
              oldValue: formatDateArray(oldParsed.dateContractExpire),
              newValue: formatDateArray(newParsed.dateContractExpire),
              oldValueEn: formatDateArray(oldParsed.dateContractExpire),
              newValueEn: formatDateArray(newParsed.dateContractExpire),
            },
            {
              movementTypeName: movementType,
              index: index + 1,
              field: "extensionProbation",
              oldValue: oldParsed.extensionProbation || "-",
              newValue: newParsed.extensionProbation || "-",
              oldValueEn: oldParsed.extensionProbation || "-",
              newValueEn: newParsed.extensionProbation || "-",
            },
            {
              movementTypeName: movementType,
              index: index + 1,
              field: "probationDate",
              oldValue: formatDateArray(oldParsed.probationDate),
              newValue: formatDateArray(newParsed.probationDate),
              oldValueEn: formatDateArray(oldParsed.probationDate),
              newValueEn: formatDateArray(newParsed.probationDate),
            },
          ];
        } else {
          const allFields = new Set([
            ...Object.keys(oldParsed),
            ...Object.keys(newParsed),
          ]);

          return Array.from(allFields).map((field) => {
            const oldVal = oldParsed[field];
            const newVal = newParsed[field];

            let oldValue = "-";
            let newValue = "-";
            let oldValueEn = "-";
            let newValueEn = "-";

            if (Array.isArray(oldVal) && typeof oldVal[0] === "number" && oldVal.length === 3) {
              oldValue = formatDateArray(oldVal);
              oldValueEn = oldValue;
            } else if (typeof oldVal === "object") {
              const { th, en } = getNamePair(oldVal, field === "supervisor");
              oldValue = th;
              oldValueEn = en;
            } else if (oldVal !== undefined) {
              oldValue = oldVal;
              oldValueEn = oldVal;
            }

            if (Array.isArray(newVal) && typeof newVal[0] === "number" && newVal.length === 3) {
              newValue = formatDateArray(newVal);
              newValueEn = newValue;
            } else if (typeof newVal === "object") {
              const { th, en } = getNamePair(newVal, field === "supervisor");
              newValue = th;
              newValueEn = en;
            } else if (newVal !== undefined) {
              newValue = newVal;
              newValueEn = newVal;
            }

            return {
              movementTypeName: movementType,
              index: index + 1,
              field,
              oldValue,
              newValue,
              oldValueEn,
              newValueEn,
            };
          });
        }
      } catch (error) {
        console.error("Error parsing segment:", { oldSegment, newSegment, error });
        return [];
      }
    });
  };


  const columnmodal = [
    {
      title: <div className="text-table">{t("employment.label.no")}</div>,
      dataIndex: "index",
      key: "index",
      width: 150,
      render: (_, __, index) => index + 1,
    },
    {
      title: <div className="text-table">{t("employment.label.movement_fild")}</div>,
      dataIndex: "field",
      key: "field",
      render: (_, record) => {
        return (
          <div>
            {t(`movementfield.${record?.field?.toLowerCase()}`, {
              defaultValue: record?.field.toLowerCase(),
            })}
          </div>
        );
      },
      width: 200,
    },
    {
      title: <div className="text-table">{t("employment.label.old_value")}</div>,
      dataIndex: "oldValue",
      key: "oldValue",
      width: 200,
      render: (_, record) => {
        const text = i18n.language === "en" ? record.oldValueEn : record.oldValue;
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
    {
      title: <div className="text-table">{t("employment.label.new_value")}</div>,
      dataIndex: "newValue",
      key: "newValue",
      width: 200,
      render: (_, record) => {
        const text = i18n.language === "en" ? record.newValueEn : record.newValue;
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
  ];

  const onApprove = useCallback(
    (record) => {

      Modal.confirm({
        title: t('dialog.confirmation.header'),
        content: (
          <>
            <p>{t('message.areYouSureConfirmToAPPROVEDTheRequest')}</p>
          </>

        ),
        onOk() {
          handleApprove({ ...record, sendingType: "APPROVED" });
        },
        okText: t('common.confirm'),
        cancelText: t('common.cancel'),
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
      });
    },
    [Modal]
  );

  const onApproveMovement = useCallback(async (record) => {
    console.log("🚀 ~ useRequestApproval ~ record:", record)

    Modal.confirm({
      title: t("dialog.confirmation.header"),
      // width: 800,
      content: (

        <>
          <p>{t('message.areYouSureConfirmToAPPROVEDTheRequest')}</p>
        </>
      ),
      async onCancel() {
        setSelectedRow(null);
        setIsModalOpen(false)
        settable(null);
      },
      async onOk() {
        try {

          let formattedNewSalary

          if (record?.movementType?.code === 'MOVEMENT_03_01' && record?.movement?.newData?.salary) {
            formattedNewSalary = record?.movement?.newData?.salary;
            formattedNewSalary = formattedNewSalary.replace(/,/g, '');
            console.log(formattedNewSalary)
          }

          console.log(record)
          dispatch(setIsLoading(true))
          const requestBody = {
            companyId: currentCompany,
            approverId: currentApprover,
            employeeId: currentApprover,
            actionId: currentApprover,
            requestIds: record?.id,
            movenmentId: record?.requestId,
            sendingType: "APPROVED",
            movement: {
              newData: formattedNewSalary ?? record?.movement?.newData
            }
          }

          const safePagination = {
            page: 0,
            size: 10,
          };

          await services.approveMovement(requestBody)
          await getPendingMovement({
            ...safePagination,
            pagingType: "pending",
          });
        } catch (error) {
          Alert({ type: "error", resultObject: error })
        } finally {
          setIsModalOpen(false)
          dispatch(setIsLoading(false))
        }
      },
      okText: t('common.confirm'),
      cancelText: t('common.cancel'),
    });

  }, [Modal, currentCompany, currentApprover, isLoading, i18n, t, selectedRow, setSelectedRow, selecttable, settable, parseDataByMovementType, selectedMenuModal, setIsModalOpen, setMenuModal, MY_REQUEST_TYPE, MENU, getWorkflow, setCurrentWorkflow, currentWorkflow, columnmodal, handleMenuChangeModal, setCurrentMenu]);

  const onRejectMovement = useCallback(async (record) => {
    Modal.confirm({
      title: t('dialog.confirmation.header'),
      // width: 800,
      content: (
        <>
          <p>{t('message.areYouSureConfirmToREJECTTheRequest')}</p>
        </>
      ),
      async onCancel() {
        setSelectedRow(null);
        setIsModalOpen(false)
        settable(null);
      },
      async onOk() {
        try {
          let formattedNewSalary

          if (record?.movementType?.code === 'MOVEMENT_03_01' && record?.movement?.newData?.salary) {
            formattedNewSalary = record?.movement?.newData?.salary;
            formattedNewSalary = formattedNewSalary.replace(/,/g, '');
            console.log(formattedNewSalary)
          }
          dispatch(setIsLoading(true))
          const requestBody = {
            companyId: currentCompany,
            approverId: currentApprover,
            employeeId: currentApprover,
            actionId: currentApprover,
            requestIds: record?.id,
            movenmentId: record?.requestId,
            sendingType: "REJECT",
            movement: {
              newData: formattedNewSalary ?? record?.movement?.newData
            }
          }

          const safePagination = {
            page: 0,
            size: 10,
          };
          await services.approveMovement(requestBody)
          await getPendingMovement({
            ...safePagination,
            pagingType: "pending",
          });
        } catch (error) {
          Alert({ type: "error", resultObject: error })
        } finally {
          dispatch(setIsLoading(false))
        }
      },
      okText: t('common.confirm'),
      cancelText: t('common.cancel'),
      okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
    })
  }, [currentCompany, currentApprover, isLoading])

  const onReject = useCallback((record) => {
    Modal.confirm({
      title: t('dialog.confirmation.header'),
      content: (
        <>
          <p>{t('message.areYouSureConfirmToREJECTTheRequest')}</p>
        </>
      ),
      onOk() {
        handleApprove({ ...record, sendingType: "REJECT" });
      },
      okText: t('common.confirm'),
      cancelText: t('common.cancel'),
      okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
    });
  }, []);

  const onCancel = useCallback((record) => {
    Modal.confirm({
      title: "Confirmation",
      content: (
        <>
          <p>Are you sure confirm to CANCEL the request ?</p>
        </>
      ),
      onOk() {
        handleApprove({ ...record, sendingType: "CANCELLED" });
      },
      okText: "CONFIRM",
      cancelText: "CANCEL",
      okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
      cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
    });
  }, []);

  const onReturn = useCallback(
    (record) => {
      Modal.confirm({
        title: "Confirmation",
        content: (
          <>
            <p>Are you sure confirm to RETURN the request ?</p>
          </>
        ),
        onOk() {
          handleApprove({ ...record, sendingType: "RETURN" });
        },
        okText: "CONFIRM",
        cancelText: "CANCEL",
        okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
        cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
      });
    },
    [pendingTab, currentCompany, currentApprover]
  );

  const getMyRequest = useCallback(async (record = {}) => {

    let param = {
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: record?.employee?.employeeId
    };
    let data = {};
    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.LEAVE:
        data = await service.getLeaveRequestByIdRequest({
          ...param,
          leaveRequestId: record?.requestId,
        });
        return {
          ...data,
        };
      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        data = await service.getOffsiteWorkRequestByIdRequest({
          ...param,
          offsiteWorkRequestId: record.requestId,
        });
        return {
          ...data,
          startDate: dayjs(data?.startDate),
          endDate: dayjs(data.endDate),
        };
      case REQUEST_APPROVE_TAB.REDEEM_TIME:
        data = await service.getRedeemTimeRequestByIdRequest({
          ...param,
          redeemTimeRequestId: record.redeemTimeRequestId,
        });
        return {
          ...data,
          redeemDate: dayjs(data.redeemDate),
        };
      case REQUEST_APPROVE_TAB.ENDORSETIME:
        data = await service.getEndorseTimeRequestByIdRequest({
          ...param,
          endorseMentDate: record.endorseDate,
          endorseTimeRequestId: record.requestId,
        });
        return {
          ...data,
          endorseMentDate: dayjs(data.timeEndorsementDate),
        };
      case REQUEST_APPROVE_TAB.OVERTIME:
        data = await service.getOvertimeRequestByIdRequest({
          ...param,
          overtimeRequestId: record.requestId,
        });
        return {
          ...data,
          startDate: dayjs(data?.startDate),
        };
      case REQUEST_APPROVE_TAB.COLLECT_TIME:

        data = await service.getCollectTimeRequestByIdRequest({
          ...param,
          collectTimeRequestId: record.collectTimeRequestId,
        });
        return { ...data, startDate: dayjs(data.startDate) };
      case REQUEST_APPROVE_TAB.REQUESTFORM:
        data = await service.getDocumentRequestByIdRequest({
          ...param,
          documentRequestId: record.requestId,
        });
        return {
          ...data,
          preferredDate: dayjs(data?.preferredDate),
          travelDate: dayjs(data?.travelDate),
        };
      case REQUEST_APPROVE_TAB.CHANGE_SHIFT:

        data = await service.getChangeShiftRequestByIdRequest({
          ...param,
          changeShiftRequestId: record.changeShiftRequestId,
        });
        return { ...data };
      case REQUEST_APPROVE_TAB.WARNING_LETTER:
        data = await service.getWarningLetterByIdRequest({
          ...param,
          warningLetterRequestId: record.warningLetterRequestId,
        });
        return {
          ...data,
          incidentDate: dayjs(data.incidentDate),
          startDate: dayjs(data?.startDate),
          endDate: dayjs(data.endDate),
          createDate: dayjs(data.createDate),
          effectiveDate: dayjs(data.effectiveDate),
        };
      default:
        return {};
    }
  }, [currentCompany, selectedMenu, pendingTab]);

  const onOpenModal = useCallback(async (record) => {
    let editingData

    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.LEAVE:
        setRecordData({ ...record, table: REQUEST_APPROVE_TAB.LEAVE })
        editingData = await getMyRequest(record);
        setCurrentMyRequest({ ...editingData?.data });
        getLeaveGroupOptions({ ...editingData?.data })
        break;
      case REQUEST_APPROVE_TAB.OVERTIME:
        setRecordData({ ...record, table: REQUEST_APPROVE_TAB.OVERTIME })
        editingData = await getMyRequest(record);
        setCurrentMyRequest({ ...editingData?.data });
        break;

      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        setRecordData({ ...record, table: REQUEST_APPROVE_TAB.OFFSITEWORK })
        editingData = await getMyRequest(record);
        setCurrentMyRequest({ ...editingData?.data });
        console.log("data ", record);

        onOffsiteWorkTypeChange({ ...record, id: record?.workType?.leaveTypeId });
        break;

      case REQUEST_APPROVE_TAB.ENDORSETIME:
        setRecordData({ ...record, table: REQUEST_APPROVE_TAB.ENDORSETIME })
        editingData = await getMyRequest(record);
        setCurrentMyRequest({ ...editingData?.data });
        break;

      case REQUEST_APPROVE_TAB.REQUESTFORM:
        setRecordData({ ...record, table: REQUEST_APPROVE_TAB.REQUESTFORM })
        editingData = await getMyRequest(record);
        setCurrentMyRequest({ ...editingData?.data });
        break;

      default:
        break;
    }

    setModalOpen(true)
  }, [getMyRequest, getLeaveGroupOptions, pendingTab,
    onOffsiteWorkTypeChange
  ])

  const onCancelModal = () => {
    setModalOpen(false)
  }

  const handleApprove = useCallback(
    async (values) => {

      const baseParams = {
        companyId: currentCompany,
        approverId: currentApprover,
        sendingType: values?.sendingType,
        attachFiles: [],
      };

      const params = values?.table === REQUEST_APPROVE_TAB.EXPENSE || pendingTab === REQUEST_APPROVE_TAB.EXPENSE
        ? { ...baseParams, requestIds: values?.txnExpenseApproveId }
        : { ...baseParams, requestIds: values?.id };

      if (values?.table) {
        switch (values?.table) {
          case REQUEST_APPROVE_TAB.LEAVE:
            await approveLeaveRequest(params);
            break;

          case REQUEST_APPROVE_TAB.OFFSITEWORK:
            await approveOffsiteWorkRequest(params);
            break;

          case REQUEST_APPROVE_TAB.REDEEMTIME:
            await approveRedeemTimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.ENDORSETIME:
            await approveEndorseTimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.OVERTIME:
            await approveOvertimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.COLLECTTIME:
            await approveCollectTimeRequest(params);
            break;
          case REQUEST_APPROVE_TAB.EXPENSE:
            approveExpenseRequest(params);
            break;
          case REQUEST_APPROVE_TAB.REQUESTFORM:
            await approveDocumentlist(params);
            break;
          case REQUEST_APPROVE_TAB.CHANGESHIFT:
            await approveChangeShift(params);
            break;
          case REQUEST_APPROVE_TAB.MOVEMENT:
            await approveMovement(params);
            break;
          case REQUEST_APPROVE_TAB.WARNING_LETTER:
            await approveWarningLetter(params);
            break;
          default:
            break;
        }
      } else {
        switch (pendingTab) {
          case REQUEST_APPROVE_TAB.LEAVE:
            await approveLeaveRequest(params);
            break;

          case REQUEST_APPROVE_TAB.OFFSITEWORK:
            await approveOffsiteWorkRequest(params);
            break;

          case REQUEST_APPROVE_TAB.REDEEMTIME:
            await approveRedeemTimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.ENDORSETIME:
            await approveEndorseTimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.OVERTIME:
            await approveOvertimeRequest(params);
            break;

          case REQUEST_APPROVE_TAB.COLLECTTIME:
            await approveCollectTimeRequest(params);
            break;
          case REQUEST_APPROVE_TAB.EXPENSE:
            await approveExpenseRequest(params);
            break;
          case REQUEST_APPROVE_TAB.REQUESTFORM:
            await approveDocumentlist(params);
            break;
          case REQUEST_APPROVE_TAB.CHANGESHIFT:
            await approveChangeShift(params);
            break;
          case REQUEST_APPROVE_TAB.MOVEMENT:
            await approveMovement(params);
            break;
          case REQUEST_APPROVE_TAB.WARNING_LETTER:
            await approveWarningLetter(params);
            break;
          default:
            break;
        }
      }
      if (isModalOpen) {
        onHistory(pagination);
      } else {
        handleQueryPending(pagination);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      currentCompany,
      pendingTab,
      sorter,
      isLoading,
      currentApprover,
      isModalOpen,
      pagination,
    ]
  );

  const approve = () => {
    onApprove(recordData)
    setModalOpen(false);
  }
  const reject = () => {
    onReject(recordData)
    setModalOpen(false);
  }

  const modalReTurn = useMemo(() => {
    if (!modalOpen) return undefined;
    console.log("pendingTab 2", pendingTab);

    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.LEAVE:
        return {
          title: <Flex gap={8}>
            <span>{t('leave-request')}</span>
            <span>{`(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <LeaveForm
              initialValues={currentMyRequest}
              leaveGroupOptions={modifiedLeaveGroupOptions}
              standAlone={false}
              modalType={"view"}
              approvalPage={true}
              approveType={REQUEST_APPROVE_TAB.LEAVE}
              onApprove={approve}
              onReject={reject}
            />
          ),
        };
      case REQUEST_APPROVE_TAB.ENDORSETIME:
        return {
          title:
            <Flex gap={8}>
              <span>{t('endorse-time-request')}</span>
              <span>{`(${currentMyRequest?.sequence})`}</span>
            </Flex>,
          width: 510,
          content: (
            <EndorseTimeForm
              initialValues={currentMyRequest}
              standAlone={false}
              modalType={"view"}
              approvalPage={true}
              approveType={REQUEST_APPROVE_TAB.ENDORSETIME}
              onApprove={approve}
              onReject={reject}
            />
          ),
        };
      case REQUEST_APPROVE_TAB.OVERTIME:
        return {
          title: <Flex gap={8}>
            <span>{t('ot_request')}</span>
            <span>{`(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <OvertimeForm
              initialValues={currentMyRequest}
              standAlone={false}
              modalType={"view"}
              approvalPage={true}
              approveType={REQUEST_APPROVE_TAB.OVERTIME}
              onApprove={approve}
              onReject={reject}
            />
          ),
        };

      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        return {
          title: <Flex gap={8}>
            <span>{t('offsite_work_request')}</span>
            <span>{`(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <OffsiteForm
              initialValues={currentMyRequest}
              modifiedOffSiteOptions={modifiedOffSiteOptions}
              standAlone={false}
              modalType={"view"}
              approvalPage={true}
              approveType={REQUEST_APPROVE_TAB.OFFSITEWORK}
              onApprove={approve}
              onReject={reject}
              modifiedWorkInLocationOption={modifiedWorkInLocationOption}
            />
          ),
        };

      case REQUEST_APPROVE_TAB.REQUESTFORM:
        return {
          title: <Flex gap={8}>
            <span>{t('document_request.header')}</span>
            <span>{`(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <DocumentForm
              initialValues={currentMyRequest}
              documentTypeOptions={modifiedDocumentTypeOptions}
              standAlone={false}
              modalType="view"
              approveType={REQUEST_APPROVE_TAB.REQUESTFORM}
              onApprove={approve}
              onReject={reject}
            />
          )
        }
      case REQUEST_APPROVE_TAB.WARNING_LETTER:
        console.log("22");
        return {
          title: <Flex gap={8}>
            <span>{t('warning_letter.header')}</span>
            <span>{`(${currentMyRequest?.sequence})`}</span>
          </Flex>,
          width: 510,
          content: (
            <LeaveForm
              initialValues={currentMyRequest}
              leaveGroupOptions={modifiedLeaveGroupOptions}
              standAlone={false}
              modalType={"view"}
              approvalPage={true}
              approveType={REQUEST_APPROVE_TAB.LEAVE}
              onApprove={approve}
              onReject={reject}
            />
          ),
        };

      default:
        break;
    }
  }, [currentMyRequest, modifiedLeaveGroupOptions, t, modifiedDocumentTypeOptions, pendingTab, modifiedWorkInLocationOption, modalOpen])

  const handleMenuChange = useCallback((e) => {
    if (e === "branch_list") {
      setPageType(PAGE_TYPE.main);
    } else {
      setPageType(PAGE_TYPE.view);
    }
    setMenu(e);
  }, []);

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case "pending_approval":
        return <PendingApprovalContent />;
      case "warning_letter":
        return <WarningLetter />;
      default:
        return <div />;
    }
  }, [selectedMenu, pageType]);

  const getPendingLeaveLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });
        const response = await services.getPendingLeaveRequest({
          ...params,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });

        setPagination({
          ...pagination,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          total: response.data?.totalItems,
        });

        // setPagination({
        //   ...modifiedParams.pagination,
        //   total: response.data?.totalItems,
        // });

        if (params?.pagingType === "history") {
          dispatch(setHistoryLeaveList(response?.data?.content || []));
        } else {
          dispatch(setPendingLeaveList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingOffsiteWorkLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingOffsiteWorkRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });

        setPagination({
          ...pagination,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // total: response.data?.totalItems,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryOffsiteWorkList(response?.data?.content || []));
        } else {
          dispatch(setPendingOffsiteWorkList(response.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingCollectTimeLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingCollectTimeRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });

        setPagination({
          ...pagination,
          // // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryCollectTimeList(response?.data?.content || []));
        } else {
          dispatch(setPendingCollectTimeList(response.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingOvertimeLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingOvertimeRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryOvertimeList(response?.data?.content || []));
        } else {
          dispatch(setPendingOvertimeList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingEndorseTimeLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingEndorseTimeRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryEndorseTimeList(response?.data?.content || []));
        } else {
          dispatch(setPendingEndorseTimeList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingRedeemTimeLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingRedeemTimeRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });
        if (params?.pagingType === "history") {
          dispatch(setHistoryRedeemTimeList(response?.data?.content || []));
        } else {
          dispatch(setPendingRedeemTimeList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );

  const getPendingExpense = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingExpensePaging({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });

        setPagination({
          ...params?.pagination,
          current: response?.data?.page?.number + 1,
          pageNo: response?.data?.page?.number + 1,
          page: response?.data?.page?.number + 1,
          total: response.data?.page?.totalElements,
          size: response?.data?.page?.size
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryExpense(response?.data?.page?.content || []));
        } else {
          dispatch(setPendindExpenseList(response?.data?.page?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );


  function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format(reFormat);
  }






  const getPendingMovement = useCallback(
    async (params) => {
      try {
        dispatch(setIsLoading(true));


        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });
        const response = await services.getPendingMovement({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          employeeId: params?.employeeId === currentApprover ? null : params?.employeeId,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });

        if (response?.data?.content) {
          const transformedPendingMovement = response.data?.content.map((movement) => {
            if (movement.movement?.oldData?.employmentDate) {
              movement.movement.oldData.employmentDate = i18n.language === "en" ? dayjs(
                movement.movement.oldData.employmentDate
              ).format('DD/MM/YYYY') : dayjs(movement.movement.oldData.employmentDate).format('DD/MM/BBBB');;
            }

            if (movement.movement?.newData?.employmentDate) {
              movement.movement.newData.employmentDate = i18n.language === "en" ? dayjs(
                movement.movement.newData.employmentDate
              ).format('DD/MM/YYYY') : dayjs(movement.movement.newData.employmentDate).format('DD/MM/BBBB');;
            }

            if (movement.movement?.oldData?.probationDate) {
              movement.movement.oldData.probationDate = i18n.language === "en" ? dayjs(
                movement.movement.oldData.probationDate
              ).format('DD/MM/YYYY') : dayjs(movement.movement.oldData.probationDate).format('DD/MM/BBBB');
            }

            if (movement.movement?.newData?.probationDate) {
              movement.movement.newData.probationDate = i18n.language === "en" ? dayjs(
                movement.movement.newData.probationDate
              ).format('DD/MM/YYYY') : dayjs(movement.movement.newData.probationDate).format('DD/MM/BBBB');
            }

            if (movement.movement?.oldData?.dateofexpriaion) {
              movement.movement.oldData.dateofexpriaion = i18n.language === "en" ? dayjs(
                movement.movement.oldData.dateofexpriaion
              ).format('DD/MM/YYYY') : dayjs(movement.movement.oldData.dateofexpriaion).format('DD/MM/BBBB');
            }


            if (movement.movement?.newData?.dateofexpriaion) {
              movement.movement.newData.dateofexpriaion = i18n.language === "en" ? dayjs(
                movement.movement.newData.dateofexpriaion
              ).format('DD/MM/YYYY') : dayjs(movement.movement.newData.dateofexpriaion).format('DD/MM/BBBB');
            }

            return movement;
          });



          if (params?.pagingType === "history") {
            dispatch(setHistoryMovement(transformedPendingMovement || []));
          } else {
            dispatch(setPendingMovement(transformedPendingMovement || []));
          }
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, isLoading, pagination, i18n]
  );

  const getPendingChangeShiftLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getPendingChangeShiftRequest({
          ...params,
          // ...pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });

        if (params?.pagingType === "history") {
          dispatch(setHistoryChangeShiftList(response?.data?.content || []));
        } else {
          dispatch(setPendingChangeShiftList(response?.data?.content || []));
        }
        setPagination({
          page: params.page + 1,
          size: params.size,
          // range: [
          //   params.page * params.size + 1,
          //   Math.min((params.page + 1) * params.size, response.data?.totalItems),
          // ],
          total: response.data?.totalItems,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, dispatch, pagination]
  );
  const getPendingWarningLetterLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getPendingWarningLetterRequest({
          ...params,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          total: response.data?.totalItems,
        });
        if (params?.pagingType === "history") {
          dispatch(setHistoryWarningLetterList(response?.data?.content || []));
        } else {
          dispatch(setPendingWarningLetterList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, currentApprover, pagination]
  );
  const getPendingDocumentLists = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));

        // const modifiedParams = toParams({
        //   pagination: {
        //     page: params.current ? params.current - 1 : 0,
        //     pageSize: params.pageSize || pagination.pageSize || 10,
        //   },
        // });

        const response = await services.getPendingDocumentRequest({
          ...params,
          // ...pagination,
          // ...modifiedParams.pagination,
          companyId: currentCompany,
          approverId: currentApprover,
          pagingType: params?.pagingType ? params?.pagingType : "pending",
        });
        setPagination({
          ...pagination,
          // ...params?.request,
          current: response?.data?.pageNo + 1,
          pageNo: response?.data?.totalPages + 1,
          // ...modifiedParams.pagination,
          total: response.data?.totalItems,
        });
        if (params?.pagingType === "history") {
          dispatch(setHistoryDocumentList(response?.data?.content || []));
        } else {
          dispatch(setPendingDocumentList(response?.data?.content || []));
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, dispatch, pagination]
  );

  const onSearch = useCallback(
    (values) => {
      values.startDate = values?.startDate?.format?.("YYYY-MM-DD");
      values.endDate = values?.endDate?.format?.("YYYY-MM-DD");
      values.endorseDate = values?.endorseDate?.format?.("YYYY-MM-DD");
      values.collectDate = values?.collectDate?.format?.("YYYY-MM-DD");
      values.incidentDate = values?.incidentDate
        ? dayjs(values.incidentDate).startOf('day').toISOString()
        : undefined;
      const safePagination = {
        page: 0,
        size: 10,
      };

      switch (pendingTab) {
        case REQUEST_APPROVE_TAB.LEAVE:
          getPendingLeaveLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.OFFSITEWORK:
          getPendingOffsiteWorkLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.REDEEMTIME:
          getPendingRedeemTimeLists({
            ...safePagination,
            ...values,
          });
          break;

        case REQUEST_APPROVE_TAB.ENDORSETIME:
          getPendingEndorseTimeLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.OVERTIME:
          getPendingOvertimeLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.COLLECTTIME:
          getPendingCollectTimeLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.EXPENSE:
          getPendingExpense({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.REQUESTFORM:
          getPendingDocumentLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.CHANGESHIFT:
          getPendingChangeShiftLists({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.MOVEMENT:
          getPendingMovement({
            ...safePagination,
            ...values,
          });
          break;
        case REQUEST_APPROVE_TAB.WARNING_LETTER:
          getPendingWarningLetterLists({
            ...safePagination,
            ...values
          });
          break;
        // case "PendingApprovalHistoryTable":
        //   onHistory()
        //   break;

        default:
          break;
      }
    },
    [
      pendingTab,
      getPendingLeaveLists,
      pagination,
      getPendingOffsiteWorkLists,
      getPendingRedeemTimeLists,
      getPendingEndorseTimeLists,
      getPendingOvertimeLists,
      getPendingCollectTimeLists,
      getPendingExpense,
      getPendingDocumentLists,
      getPendingChangeShiftLists,
      getPendingWarningLetterLists,
      getPendingMovement,
    ]
  );

  const table = useCallback(() => {
    switch (selectedMenu) {
      case "pending_approval":
        return pendingTable();
      case "warning_letter":
        return <WarningLetter />;
      default:
        return <div />;
    }
  }, [
    selectedMenu,
    currentApprover,
    currentCompany,
    isLoading,
    onEdit,
    onView,
    onMain,
    pendingTab,
    pagination,
  ]);

  const onHistory = useCallback(
    async (params) => {
      try {
        dispatch(setIsLoading(true));
        switch (pendingTab) {
          case REQUEST_APPROVE_TAB.LEAVE:
            await getPendingLeaveLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.OFFSITEWORK:
            await getPendingOffsiteWorkLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.REDEEMTIME:
            await getPendingRedeemTimeLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.ENDORSETIME:
            await getPendingEndorseTimeLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.OVERTIME:
            await getPendingOvertimeLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.COLLECTTIME:
            await getPendingCollectTimeLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.EXPENSE:
            await getPendingExpense({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.REQUESTFORM:
            await getPendingDocumentLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.CHANGESHIFT:
            await getPendingChangeShiftLists({
              ...params,
              pagingType: "history",
            });
            break;

          case REQUEST_APPROVE_TAB.MOVEMENT:
            await getPendingMovement({
              ...params,
              pagingType: "history",
            });
            break;
          case REQUEST_APPROVE_TAB.WARNING_LETTER:
            await getPendingWarningLetterLists({
              ...params,
              pagingType: "history"
            });
            break;

          default:
            break;
        }
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pagination, currentApprover, currentCompany, pendingTab]
  );

  const handleQueryPending = useCallback(
    async (params) => {
      switch (pendingTab) {
        case REQUEST_APPROVE_TAB.LEAVE:
          getPendingLeaveLists(params);
          break;
        case REQUEST_APPROVE_TAB.OFFSITEWORK:
          getPendingOffsiteWorkLists(params);
          break;
        case REQUEST_APPROVE_TAB.REDEEMTIME:
          getPendingRedeemTimeLists(params);
          break;

        case REQUEST_APPROVE_TAB.ENDORSETIME:
          getPendingEndorseTimeLists(params);
          break;
        case REQUEST_APPROVE_TAB.OVERTIME:
          getPendingOvertimeLists(params);
          break;
        case REQUEST_APPROVE_TAB.COLLECTTIME:
          getPendingCollectTimeLists(params);
          break;
        case REQUEST_APPROVE_TAB.EXPENSE:
          getPendingExpense(params);
          break;
        case REQUEST_APPROVE_TAB.REQUESTFORM:
          getPendingDocumentLists(params);
          break;
        case REQUEST_APPROVE_TAB.CHANGESHIFT:
          getPendingChangeShiftLists(params);
          break;
        case REQUEST_APPROVE_TAB.MOVEMENT:
          getPendingMovement(params);
          break;
        case REQUEST_APPROVE_TAB.WARNING_LETTER:
          getPendingWarningLetterLists(params);
          break;
        default:
          break;
      }
    },
    [
      pendingTab,
      getPendingLeaveLists,
      getPendingOffsiteWorkLists,
      getPendingRedeemTimeLists,
      getPendingEndorseTimeLists,
      getPendingOvertimeLists,
      getPendingCollectTimeLists,
      getPendingExpense,
      getPendingDocumentLists,
      getPendingChangeShiftLists,
      getPendingMovement,
    ]
  );

  const onPageChange = useCallback(
    (tablePagination, tableFilters, tableSorter, tableExtra) => {
      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];

      if (pendingTab === REQUEST_APPROVE_TAB.EXPENSE) {
        const modifiedParams = toParams({
          pagination: {
            page: tablePagination?.current - 1,
            size: tablePagination?.pageSize,
            pageSize: tablePagination?.pageSize,
            current: tablePagination.current - 1,
          },
          sortBy: modifiedSorter,
        });

        setPagination({
          page: modifiedParams?.pagination?.page + 1,
          size: modifiedParams?.pagination?.size,
          total: tablePagination.totalElements,
        });

        if (isModalOpen) {
          getPendingExpense({
            ...modifiedParams?.pagination,
            pagingType: "history"
          });
        } else {
          getPendingExpense(modifiedParams?.pagination);
        }
      } else {
        const modifiedParams = toParams({
          pagination: {
            page: tablePagination.current - 1,
            pageSize: tablePagination.pageSize,
            current: tablePagination.current - 1,
          },
          sortBy: modifiedSorter,
        });

        setPagination({ ...modifiedParams?.pagination });

        if (isModalOpen) {
          onHistory({ ...modifiedParams?.pagination });
        } else {
          handleQueryPending({ ...modifiedParams?.pagination });
        }
      }
    },
    [pagination, pendingTab, isModalOpen, onHistory, handleQueryPending, getPendingExpense]
  );

  const pendingTable = useCallback(() => {
    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.LEAVE:
        return (
          <PendingApprovalLeaveTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            dataSource={getLeaveRequest}
            onOpenModal={onOpenModal}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
            pageType={pageType}
          />
        );

      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        return (
          <PendingApprovalOffsiteWorkTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            dataSource={getOffsiteWorkRequest}
            onOpenModal={onOpenModal}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
            pageType={pageType}
          />
        );

      case REQUEST_APPROVE_TAB.REDEEMTIME:
        return (
          <PendingApprovalRedeemTimeTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            dataSource={getRedeemTimeRequest}
          />
        );

      case REQUEST_APPROVE_TAB.ENDORSETIME:
        return (
          <PendingApprovalEndorseTimeTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            dataSource={getEndorseTimeRequest}
            onOpenModal={onOpenModal}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
            pageType={pageType}
          />
        );

      case REQUEST_APPROVE_TAB.OVERTIME:
        return (
          <PendingApprovalOvertimeTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            isModalOpen={isModalOpen}
            dataSource={getOvertimeRequest}
            onOpenModal={onOpenModal}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
            pageType={pageType}
          />
        );

      case REQUEST_APPROVE_TAB.COLLECTTIME:
        return (
          <PendingApprovalCollectTimeTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={getCollectTimeRequest}
          />
        );

      case REQUEST_APPROVE_TAB.EXPENSE:
        return (
          <PendingApprovalExpenseTable
            isLoading={isLoading}
            onApprove={onApprove}
            onReject={onReject}
            onReturn={onReturn}
            onCancel={onCancel}
            pagination={pagination}
            onChange={onPageChange}
            dataSource={getPendingExpenseSlice}
            pageType={pageType}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
            onView={onViewApproveExpense}
            txnExpenseById={txnExpenseById}
          />
        );

      case REQUEST_APPROVE_TAB.REQUESTFORM:
        return (
          <RequestFormTable
            onApprove={onApprove}
            onCancel={onCancel}
            onReject={onReject}
            onReturn={onReturn}
            dataSource={pendingDocumentList}
            isLoading={isLoading}
            pagination={pagination}
            onChange={onPageChange}
            onOpenModal={onOpenModal}
            pageType={pageType}
            onApproveAll={onApproveAll}
            onRejectAll={onRejectAll}
          />
        );

      case REQUEST_APPROVE_TAB.CHANGESHIFT:
        return (
          <ChangeShiftTable
            onApprove={onApprove}
            onCancel={onCancel}
            onReject={onReject}
            onReturn={onReturn}
            dataSource={pendingChangeShiftList}
            isLoading={isLoading}
            pagination={pagination}
            onChange={onPageChange}
          />
        );

      case REQUEST_APPROVE_TAB.MOVEMENT:
        return <Movement
          dataSource={pendingMovement}
          isLoading={isLoading}
          pagination={pagination}
          isModalOpen={isModalOpen}
          onChange={onPageChange}
          setModalOpen={setModalOpen}
          onApprove={onApproveMovement}
          onReject={onRejectMovement}
        />;
      case REQUEST_APPROVE_TAB.WARNING_LETTER:
        return <WarningLetter
          dataSource={pendingMovement}
          isLoading={isLoading}
          pagination={pagination}
          isModalOpen={isModalOpen}
          onChange={onPageChange}
          setModalOpen={setModalOpen}
          onApprove={onApproveMovement}
          onReject={onRejectMovement}
        />;
      default:
        break;
    }
  }, [
    pendingTab,
    isLoading,
    onApprove,
    onReject,
    onReturn,
    onCancel,
    pagination,
    onPageChange,
    getLeaveRequest,
    onOpenModal,
    getOffsiteWorkRequest,
    getRedeemTimeRequest,
    getEndorseTimeRequest,
    isModalOpen,
    getOvertimeRequest,
    getCollectTimeRequest,
    getPendingExpenseSlice,
    pendingDocumentList,
    pendingChangeShiftList,
  ]);

  const modalHistory = useCallback(() => {
    switch (pendingTab) {
      case REQUEST_APPROVE_TAB.LEAVE:
        return (
          <PendingApprovalLeaveTable
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyLeaveList}
            modalFlag={false}
          />
        );

      case REQUEST_APPROVE_TAB.OFFSITEWORK:
        return (
          <PendingApprovalOffsiteWorkTable
            modalFlag={false}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyOffsiteWorkList}
          />
        );

      case REQUEST_APPROVE_TAB.REDEEMTIME:
        return (
          <PendingApprovalRedeemTimeTable
            modalFlag={false}
            isModalOpen={isModalOpen}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyRedeemTimeList}
          />
        );

      case REQUEST_APPROVE_TAB.ENDORSETIME:
        return (
          <PendingApprovalEndorseTimeTable
            modalFlag={false}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyEndorseTimeList}
          />
        );

      case REQUEST_APPROVE_TAB.OVERTIME:
        return (
          <PendingApprovalOvertimeTable
            isLoading={isLoading}
            isModalOpen={isModalOpen}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyOvertimeList}
            modalFlag={false}
          />
        );

      case REQUEST_APPROVE_TAB.COLLECTTIME:
        return (
          <PendingApprovalCollectTimeTable
            modalFlag={false}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyCollectTimeList}
          />
        );

      case REQUEST_APPROVE_TAB.EXPENSE:
        return (
          <PendingApprovalExpenseTable
            modalFlag={false}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyExpense}
          />
        );

      case REQUEST_APPROVE_TAB.REQUESTFORM:
        return (
          <RequestFormTable
            modalFlag={false}
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyDocumentList}
          />
        );

      case REQUEST_APPROVE_TAB.CHANGESHIFT:
        return (
          <ChangeShiftTable
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyChangeShiftList}
          />
        );

      case REQUEST_APPROVE_TAB.MOVEMENT:
        return (
          <Movement
            isLoading={isLoading}
            onChange={onPageChange}
            pagination={pagination}
            dataSource={historyMovement}
          />
        );
      default:
        break;
    }
  }, [
    pendingTab,
    historyOffsiteWorkList,
    historyRedeemTimeList,
    historyEndorseTimeList,
    historyOvertimeList,
    historyCollectTimeList,
    historyWarningLetterList,
    historyDocumentList,
    historyChangeShiftList,
    historyExpense,
    historyMovement,
    isLoading,
    onPageChange,
    pagination,
  ]);

  const approveLeaveRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveLeaveRequest(values);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveOffsiteWorkRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveOffsiteWorkRequest(values);

        getPendingOffsiteWorkLists({
          ...pagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveRedeemTimeRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));

        await services.approveRedeemTimeRequest(values);
        getPendingRedeemTimeLists({
          ...pagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveEndorseTimeRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveEndorseTimeRequest(values);

        getPendingEndorseTimeLists({
          ...pagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading, pagination]
  );

  const approveOvertimeRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveOvertimeRequest(values);

        getPendingOvertimeLists({
          ...pagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading, pagination]
  );

  const approveCollectTimeRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveCollectTimeRequest(values);

        getPendingCollectTimeLists({
          ...pagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading, pagination]
  );

  const approveExpenseRequest = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveandRejectExpenseRequest(values);

        const safePagination = {
          page: 0,
          size: 10,
        };

        getPendingExpense({
          ...safePagination,
        });
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveMovement = useCallback(
    async (record) => {
      try {
        dispatch(setIsLoading(true));
        const requestBody = {
          companyId: currentCompany,
          approverId: currentApprover,
          employeeId: currentApprover,
          actionId: currentApprover,
          requestIds: record?.requestId,
          sendingType: "APPROVED",
        };
        await services.approveMovement(requestBody);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveDocumentlist = useCallback(
    async (record) => {
      try {
        dispatch(setIsLoading(true));
        await services.approveDocumentRequest(record);

        const safePagination = {
          page: 0,
          size: 10,
        };

        getPendingDocumentLists({
          ...safePagination
        })
        message.success(t("common.success"))
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveChangeShift = useCallback(
    async (record) => {
      try {
        dispatch(setIsLoading(true));
        const requestBody = {
          companyId: currentCompany,
          approverId: currentApprover,
          sendingType: record.sendingType,
          requestIds: record.requestId,
        };
        await services.approveChangeShiftRequest(requestBody);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const approveWarningLetter = useCallback(
    async (record) => {
      try {
        dispatch(setIsLoading(true));
        const requestBody = {
          companyId: currentCompany,
          approverId: currentApprover,
          sendingType: record.sendingType,
          requestIds: record.requestId,
        };
        await services.approveWarningLetterRequest(requestBody);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentApprover, isLoading]
  );

  const handleApproveAll = useCallback(
    async (selectedRecords) => {
      const isExpense = pendingTab === REQUEST_APPROVE_TAB.EXPENSE;

      const baseParams = {
        companyId: currentCompany,
        approverId: currentApprover,
        sendingType: "APPROVED",
        actionId: currentApprover,
      };

      const params = isExpense
        ? {
          ...baseParams,
          requestIds: selectedRecords.map(record => record.txnExpenseApproveId)
        }
        : {
          ...baseParams,
          requestIds: selectedRecords.map(record => record.id)
        };

      switch (pendingTab) {
        case REQUEST_APPROVE_TAB.LEAVE:
          await approveLeaveRequest(params);
          break;

        case REQUEST_APPROVE_TAB.OFFSITEWORK:
          await approveOffsiteWorkRequest(params);
          break;

        case REQUEST_APPROVE_TAB.ENDORSETIME:
          await approveEndorseTimeRequest(params);
          break;

        case REQUEST_APPROVE_TAB.OVERTIME:
          await approveOvertimeRequest(params);
          break;

        case REQUEST_APPROVE_TAB.EXPENSE:
          await approveExpenseRequest(params);
          break;

        case REQUEST_APPROVE_TAB.REQUESTFORM:
          await approveDocumentlist(params);
          break;

        default:
          break;
      }
      await handleQueryPending({ page: 0, size: 10 });
    }
    , [approveDocumentlist, approveEndorseTimeRequest, approveExpenseRequest, approveLeaveRequest, approveOffsiteWorkRequest, approveOvertimeRequest, currentApprover, currentCompany, handleQueryPending, pendingTab])

  const onApproveAll = useCallback(
    (selectedRecords) => {
      return new Promise((resolve) => {
        const count = selectedRecords.length;

        Modal.confirm({
          title: i18n.language === "en" ? `Do you want to approve all ${count} selected requests ?`
            : `คุณต้องการอนุมัติคำขอที่เลือก ทั้งหมด ${count} รายการหรือไม่ ?`,
          content: (
            <>
              <p>{t('message.if_approved_cant_cancel')}</p>
            </>
          ),
          onOk() {
            return handleApproveAll(selectedRecords).then(resolve);
          },
          okText: t('common.confirm'),
          cancelText: t('common.cancel'),
          okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
          cancelButtonProps: { style: { height: "40px", borderRadius: "8px", boxShadow: "none" } },
        });
      });
    },
    [handleApproveAll, i18n.language, t]
  );

  const handleRejectAll = useCallback(
    async (selectedRecords) => {
      const isExpense = pendingTab === REQUEST_APPROVE_TAB.EXPENSE;

      const baseParams = {
        companyId: currentCompany,
        approverId: currentApprover,
        sendingType: "REJECT",
        actionId: currentApprover,
      };

      const params = isExpense
        ? {
          ...baseParams,
          requestIds: selectedRecords.map(record => record.txnExpenseApproveId)
        }
        : {
          ...baseParams,
          requestIds: selectedRecords.map(record => record.id)
        };

      switch (pendingTab) {
        case REQUEST_APPROVE_TAB.LEAVE:
          await approveLeaveRequest(params);
          break;

        case REQUEST_APPROVE_TAB.OFFSITEWORK:
          await approveOffsiteWorkRequest(params);
          break;

        case REQUEST_APPROVE_TAB.ENDORSETIME:
          await approveEndorseTimeRequest(params);
          break;

        case REQUEST_APPROVE_TAB.OVERTIME:
          await approveOvertimeRequest(params);
          break;

        case REQUEST_APPROVE_TAB.EXPENSE:
          await approveExpenseRequest(params);
          break;

        case REQUEST_APPROVE_TAB.REQUESTFORM:
          await approveDocumentlist(params);
          break;

        default:
          break;
      }
      await handleQueryPending({ page: 0, size: 10 });
    }
    , [approveDocumentlist, approveEndorseTimeRequest, approveExpenseRequest, approveLeaveRequest, approveOffsiteWorkRequest, approveOvertimeRequest, currentApprover, currentCompany, handleQueryPending, pendingTab])

  const onRejectAll = useCallback(
    (selectedRecords) => {
      return new Promise((resolve) => {
        const count = selectedRecords.length;

        Modal.confirm({
          title:
            i18n.language === "en"
              ? `Do you want to reject all ${count} selected requests ?`
              : `คุณต้องการปฏิเสธคำขอที่เลือกทั้งหมด ${count} รายการหรือไม่ ?`,
          content: (
            <>
              <p>{t('message.if_rejected_cant_cancel')}</p>
            </>
          ),
          onOk() {
            return handleRejectAll(selectedRecords).then(resolve);
          },
          okText: t('common.confirm'),
          cancelText: t('common.cancel'),
          okButtonProps: {
            style: {
              height: "40px",
              borderRadius: "8px",
              backgroundColor: "var(--button-color)",
              boxShadow: "none",
            },
          },
          cancelButtonProps: {
            style: {
              height: "40px",
              borderRadius: "8px",
              boxShadow: "none",
            },
          },
        });
      });
    },
    [handleRejectAll, i18n.language, t]
  );

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
    onHistory({ page: 0, size: 10 });
  }, [onHistory, pagination]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancelModal = useCallback(() => {
    setIsModalOpen(false);

    const defaultPagination = {
      page: 0,
      size: 10,
    };

    setPagination(defaultPagination);
    handleQueryPending(defaultPagination);
  }, [handleQueryPending]);

  useEffect(() => {
    if (currentCompany && currentApprover) {
      setPagination({});
      setUseFilter(false);
      handleQueryPending({ page: 0, size: 10 });
    }
  }, [currentCompany, pendingTab, currentApprover]);

  useEffect(() => {
    dispatch(setPendingLeaveList());
    dispatch(setPendingOffsiteWorkList());
    dispatch(setPendingChangeShiftList());
    dispatch(setPendingDocumentList());
    dispatch(setPendingCollectTimeList());
    dispatch(setPendingEndorseTimeList());
    dispatch(setPendingMovement());
    dispatch(setPendingRedeemTimeList());
    dispatch(setPendingWarningLetterList());
    dispatch(setPendingOvertimeList());
  }, [dispatch]);

  useEffect(() => {
    const key = storage.sessionStorage.getItem("config.menu");
    if (REQUEST_APPROVAL_TYPE_LIST.includes(key)) {
      setMenu(key);
    } else {
      setMenu(REQUEST_APPROVAL_TYPE.PENDING_APPROVAL);
    }

  }, []);

  useEffect(() => {
    if (i18n.language === 'th') {
      setDisabledDateRange({
        startYear: dayjs("2024-01-01"),
        endYear: dayjs("2034-12-31")
      });
    } else {
      setDefaultValue(dayjs());
      setDisabledDateRange({
        startYear: dayjs("2024-01-01"),
        endYear: dayjs("2034-12-31"),
      });
    }
  }, [i18n.language]); // ฟังการเปลี่ยนแปลงของ i18n.language

  return {
    modifiedEmployeeOptions,
    modifiedOffSiteOptions,
    modifiedLeaveGroupOptions,
    modifiedCompanyRegulationOptions,
    modifiedPenaltiesOptions,
    modifiedDocumentTypeOptions,
    pageType,
    selectedMenu,
    pendingTab,
    onView,
    onEdit,
    onSearch,
    handleMenuChange,
    getPage,
    disabledDateRange,
    defaultValue,
    setDefaultValue,
    onPendingTabChange,
    table,
    modalHistory,
    onHistory,
    handleOpenModal,
    handleOk,
    handleCancelModal,
    isModalOpen,
    modalReTurn,
    modalOpen,
    onCancelModal,
    useFilter,
    setUseFilter,
  };
}

export default useRequestApproval;
